import React, { useState } from 'react';
import cls from 'classnames';
import Button from '../misc/Button';
import { setGraphInQuery, clearGraphFromQuery } from '../../lib/location';
import FileDrop from './FileDrop';
import { useSetNewGraph, useIsPreloadingGraph } from '../../hooks';
import workerPool from '../../workers/pool';
import './ImportModal.scss';
var EXAMPLES = [
    {
        id: 'arctic',
        label: 'Arctic graph',
        description: 'Description for this example is coming soon.'
    },
    {
        id: 'rio',
        label: 'RIO graph',
        description: 'Description for this example is coming soon.'
    },
    {
        id: 'basic',
        label: 'Basic graph',
        description: 'Description for this example is coming soon.'
    },
    {
        id: 'les-miserables',
        label: 'Les Misérables graph',
        description: 'Description for this example is coming soon.'
    },
    {
        id: 'sparse-monopartite',
        label: 'Sparse monopartite projection graph',
        description: 'Description for this example is coming soon.'
    },
    {
        id: 'c-elegans',
        label: 'Caenorhabditis elegans graph',
        description: 'Description for this example is coming soon.'
    },
    {
        id: 'eurosis',
        label: 'EuroSiS',
        description: 'Description for this example is coming soon.'
    }
];
function ExampleList(_a) {
    var onClick = _a.onClick;
    return (React.createElement("div", { className: "content example-list-container" },
        React.createElement("ul", { className: "example-list" }, EXAMPLES.map(function (example) {
            return (React.createElement("li", { onClick: function () { return onClick(example.id); }, key: example.id, className: "card" },
                React.createElement("div", { className: "columns card-header" },
                    React.createElement("div", { className: "column is-4" },
                        React.createElement("div", { className: "card-image" },
                            React.createElement("figure", { className: "image" },
                                React.createElement("img", { alt: "." })))),
                    React.createElement("div", { className: "column is-8" },
                        React.createElement("h5", { className: "card-header-title" }, example.label),
                        React.createElement("div", { className: "card-content" },
                            React.createElement("div", { className: "content" }, example.description))))));
        }))));
}
function UrlImportForm(_a) {
    var onSubmit = _a.onSubmit;
    var _b = useState(''), url = _b[0], setUrl = _b[1];
    return (React.createElement("div", { className: "columns" },
        React.createElement("div", { className: "column is-10" },
            React.createElement("div", { className: "field" },
                React.createElement("div", { className: "control" },
                    React.createElement("input", { type: "text", className: "input", value: url, onChange: function (e) { return setUrl(e.target.value); }, placeholder: "https://somewhere.com/data/hello-world.gexf" })))),
        React.createElement("div", { className: "column is-2" },
            React.createElement(Button, { color: "black", disabled: !url, onClick: function () { return onSubmit(url); } }, "Fetch"))));
}
var TABS = [
    {
        label: 'Load a file',
        tab: 'file'
    },
    {
        label: 'Try an example',
        tab: 'example'
    },
    {
        label: 'Fetch a URL',
        tab: 'url'
    }
];
export default function ImportModal(_a) {
    var isOpen = _a.isOpen, close = _a.close, canClose = _a.canClose;
    var _b = useState('file'), activeTab = _b[0], setActiveTab = _b[1];
    var _c = useState(false), isLoading = _c[0], setIsLoading = _c[1];
    var isPreloadingGraph = useIsPreloadingGraph()[0];
    if (isPreloadingGraph) {
        activeTab = 'url';
    }
    var setActiveTabIfDifferent = function (newActiveTab) {
        if (newActiveTab === activeTab)
            return;
        setActiveTab(newActiveTab);
    };
    var setGraph = useSetNewGraph();
    function onGraphImported(err, _a) {
        var graph = _a.graph, model = _a.model, options = _a.options;
        setIsLoading(false);
        if (err)
            return console.error(err);
        if (options.type === 'url')
            setGraphInQuery(options.url);
        else
            clearGraphFromQuery();
        setGraph(graph, model);
    }
    function loadExampleGraph(name) {
        setIsLoading(true);
        workerPool.import({ type: 'example', name: name }, onGraphImported);
    }
    function loadUrl(url) {
        setIsLoading(true);
        workerPool.import({ type: 'url', url: url.trim() }, onGraphImported);
    }
    function onDrop(file) {
        setIsLoading(true);
        workerPool.import({ type: 'file', file: file }, onGraphImported);
    }
    var body = null;
    if (isLoading || isPreloadingGraph) {
        body = React.createElement("progress", { className: "progress is-dark is-large" });
    }
    else {
        if (activeTab === 'file')
            body = React.createElement(FileDrop, { onDrop: onDrop });
        else if (activeTab === 'example')
            body = React.createElement(ExampleList, { onClick: loadExampleGraph });
        else if (activeTab === 'url')
            body = React.createElement(UrlImportForm, { onSubmit: loadUrl });
    }
    return (React.createElement("div", { id: "ImportModal", className: cls('modal', { 'is-active': isOpen, 'cant-close': !canClose }) },
        React.createElement("div", { className: "modal-background", onClick: close }),
        React.createElement("div", { className: "modal-content" },
            React.createElement("div", { className: "import-modal-box" },
                React.createElement("h2", null, "New project"),
                React.createElement("div", { className: "tabs" },
                    React.createElement("ul", null, TABS.map(function (item) {
                        return (React.createElement("li", { key: item.tab, className: cls(activeTab === item.tab && 'is-active'), onClick: setActiveTabIfDifferent.bind(null, item.tab) },
                            React.createElement("a", null, item.label)));
                    }))),
                body))));
}
